import { render, staticRenderFns } from "./QuotationDetail.vue?vue&type=template&id=998800fc&scoped=true&"
import script from "./QuotationDetail.vue?vue&type=script&lang=js&"
export * from "./QuotationDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuotationDetail.vue?vue&type=style&index=0&id=998800fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998800fc",
  null
  
)

export default component.exports